import "./src/lib/sentry";
import "expo-router/entry";
